import { Component, Input } from "@angular/core";
import { LOADER_TYPES } from "../../constants/app-enums";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {
  @Input() loaderType: LOADER_TYPES = LOADER_TYPES.SPINNER;
  @Input() loaderGif!: string;
  @Input({ required: true }) isLoading = false;
  @Input({ required: true }) loaderConfig: {
    height: number;
    thickness: number;
    isDarkBg?: boolean;
  } = {
      height: 16,
      thickness: 2,
    };
  LOADER_TYPES = LOADER_TYPES;
}
